import {
    create,
    cloneDependencies,
    isIntegerDependencies,
    isNegativeDependencies,
    isNumericDependencies,
    hasNumericValueDependencies,
    isPositiveDependencies,
    isZeroDependencies,
    isNaNDependencies,
    typeOfDependencies,
    numberDependencies,
    stringDependencies,
    unaryMinusDependencies,
    unaryPlusDependencies,
    absDependencies,
    addScalarDependencies,
    cbrtDependencies,
    ceilDependencies,
    cubeDependencies,
    expDependencies,
    expm1Dependencies,
    fixDependencies,
    floorDependencies,
    gcdDependencies,
    lcmDependencies,
    log10Dependencies,
    log2Dependencies,
    modDependencies,
    multiplyScalarDependencies,
    multiplyDependencies,
    nthRootDependencies,
    signDependencies,
    sqrtDependencies,
    squareDependencies,
    subtractDependencies,
    xgcdDependencies,
    formatDependencies,
    printDependencies,
    isPrimeDependencies,
    numericDependencies,
    divideScalarDependencies,
    powDependencies,
    roundDependencies,
    logDependencies,
    log1pDependencies,
    unitDependencies,
    acosDependencies,
    acoshDependencies,
    acotDependencies,
    acothDependencies,
    acscDependencies,
    acschDependencies,
    asecDependencies,
    asechDependencies,
    asinDependencies,
    asinhDependencies,
    atanDependencies,
    atan2Dependencies,
    atanhDependencies,
    cosDependencies,
    coshDependencies,
    cotDependencies,
    cothDependencies,
    cscDependencies,
    cschDependencies,
    secDependencies,
    sechDependencies,
    sinDependencies,
    sinhDependencies,
    tanDependencies,
    tanhDependencies,
    addDependencies,
    hypotDependencies,
    normDependencies,
    parseDependencies,
    compileDependencies,
    evaluateDependencies,
    parserDependencies,
    divideDependencies,
    reviverDependencies,
    eDependencies,
    falseDependencies,
    nullDependencies,
    phiDependencies,
    piDependencies,
    tauDependencies,
    trueDependencies,
    versionDependencies,
    equalDependencies,
    smallerDependencies,
    smallerEqDependencies,
    largerDependencies,
    largerEqDependencies,
} from "mathjs"


const mathjs = create({
    cloneDependencies,
    isIntegerDependencies,
    isNegativeDependencies,
    isNumericDependencies,
    hasNumericValueDependencies,
    isPositiveDependencies,
    isZeroDependencies,
    isNaNDependencies,
    typeOfDependencies,
    numberDependencies,
    stringDependencies,
    unaryMinusDependencies,
    unaryPlusDependencies,
    absDependencies,
    addScalarDependencies,
    cbrtDependencies,
    ceilDependencies,
    cubeDependencies,
    expDependencies,
    expm1Dependencies,
    fixDependencies,
    floorDependencies,
    gcdDependencies,
    lcmDependencies,
    log10Dependencies,
    log2Dependencies,
    modDependencies,
    multiplyScalarDependencies,
    multiplyDependencies,
    nthRootDependencies,
    signDependencies,
    sqrtDependencies,
    squareDependencies,
    subtractDependencies,
    xgcdDependencies,
    formatDependencies,
    printDependencies,
    isPrimeDependencies,
    numericDependencies,
    divideScalarDependencies,
    powDependencies,
    roundDependencies,
    logDependencies,
    log1pDependencies,
    unitDependencies,
    acosDependencies,
    acoshDependencies,
    acotDependencies,
    acothDependencies,
    acscDependencies,
    acschDependencies,
    asecDependencies,
    asechDependencies,
    asinDependencies,
    asinhDependencies,
    atanDependencies,
    atan2Dependencies,
    atanhDependencies,
    cosDependencies,
    coshDependencies,
    cotDependencies,
    cothDependencies,
    cscDependencies,
    cschDependencies,
    secDependencies,
    sechDependencies,
    sinDependencies,
    sinhDependencies,
    tanDependencies,
    tanhDependencies,
    addDependencies,
    hypotDependencies,
    normDependencies,
    parseDependencies,
    compileDependencies,
    evaluateDependencies,
    parserDependencies,
    divideDependencies,
    reviverDependencies,
    eDependencies,
    falseDependencies,
    nullDependencies,
    phiDependencies,
    piDependencies,
    tauDependencies,
    trueDependencies,
    versionDependencies,
    equalDependencies,
    smallerDependencies,
    smallerEqDependencies,
    largerDependencies,
    largerEqDependencies,
}, {})
export default mathjs
